<template>
    <b-container id="login" class="user-form">
        <b-row>
            <b-col>
                <h3>{{ getLanguage.calendarText.headerLogin }}</h3>
                <p v-if="errorMsg != ''" class="error" v-html="errorMsg">{{ errorMsg }}</p>
                <ValidationObserver v-slot="{ handleSubmit }">
                    <b-form @submit.prevent="handleSubmit(onSubmit)">
                        <b-form-group :label="`${getLanguage.formEmail}:*`">
                            <Validation-provider name="email" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="form.email" type="email" trim></b-form-input>
                                <span class="note">{{ errors[0] }}</span>
                            </Validation-provider>
                        </b-form-group>
                        <b-form-group :label="`${getLanguage.formPassword}:*`">
                            <Validation-provider name="password" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="form.password" type="password" trim></b-form-input>
                                <span class="note">{{ errors[0] }}</span>
                            </Validation-provider>
                        </b-form-group>
                        <b-button type="submit" :disabled="disabled == true" variant="primary">{{ getLanguage.formBtnLogin }}</b-button>
                        <p v-if="timer > 0">Bitte warten Sie noch <strong>{{ timer }}</strong> Sekunden ...<br>
                            Please wait <strong>{{ timer }}</strong> seconds ...</p>
                    </b-form>
                </ValidationObserver>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import store from '../store';
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';
    import { helpers } from '../shared/mixin';

    let messages = {
        required: 'Dieses Feld muss eingegeben werden!',
    };

    if (store.getters.getLangCode != 'de') {
        messages = {
            required: 'This field is required!',
        };
    }

    // validation
    extend('required', {
        ...required,
        message: messages.required
    });

    export default {
        name: "UserLogin",
        components: {
            ValidationProvider,
            ValidationObserver
        },
        mixins: [ helpers ],
        data() {
            return {
                form: {
                    email: '',
                    password: '',
                },
                errorMsg: '',
                disabled: false,
                timer: 0,
            }
        },
        methods: {
            ...mapActions(['login']),
            async onSubmit()
            {
                const response = await this.login(this.form);

                if (response.status == 422)
                {
                    this.errorMsg = this.showErrors(response.data);

                    if (response.data.maxattempts > 0)
                    {
                        this.disabled = true;
                        this.startTimer(60);
                    }
                } else {
                    // reload
                    // sonst wird manchmal nach dem login der kalender nicht gerendert!
                    location.reload();
                }
            },
            startTimer(max)
            {
                this.timer = max;

                let t = setInterval(() => {
                    this.timer = this.timer - 1;

                    if (this.timer < 0)
                    {
                        this.disabled = false;
                        this.timer = 0;
                        this.errorMsg = '';

                        clearInterval(t);
                    }
                }, 1000);
            }
        },
        computed: {
            ...mapGetters(['getLanguage']),
        }
    }
</script>

<style scoped>

</style>